'use strict';

var moment = require('moment');
var staticData = require('../config/static-data.json');
var GridExampleController = function GridExampleController($scope, dataRetrieverService) {
  $scope.modes = [{
    label: 'Basic',
    value: 'basic'
  }, {
    label: 'Settings manipulation',
    value: 'settings'
  }, {
    label: 'With selection',
    value: 'selection'
  }];
  $scope.demoMode = 'basic';
  $scope.isMode = function (mode) {
    return $scope.demoMode === mode;
  };
  $scope.loadAllData = function (market, repeat) {
    dataRetrieverService.getAllDataGridRetriever('regular', 'reservationHoldingsTotal', market, 'Default', 'EC1', undefined, moment('2018-05-01')).localSortApplied().retrieveComponentData('demand-transparency-all-data').then(function (data) {
      var array = [];
      if (repeat) {
        for (var i = 0; i < repeat; i++) {
          array.push.apply(array, data);
        }
      } else {
        array = data;
      }
      $scope.data = array;
    });
  };
  $scope.setStaticData = function () {
    $scope.data = staticData;
  };
  $scope.removeRow = function () {
    $scope.data = $scope.data.slice(1);
  };
  $scope.setStaticData();
};
GridExampleController.$inject = ['$scope', 'DemandTransparencyDataRetrieverService'];
module.exports = GridExampleController;